<div class="font-10 cout-portion-pondere" *ngIf="displayCoutsDetails" title="prix de vente" >
  {{menuCompo.udpPdPrixDeVenteWithTdp | currency:'EUR':'symbol':'1.4-4'}}</div>
